module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_7005.3b2a015a.png";